import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import config from "../../../config/index";
import { componentCheckSize } from "../../../utils/helperServices";
import { MOBILE_WIDTH } from "../../../config/constants";
import {
  Container,
  CustomContainer,
  Row,
  Col,
  Modal,
  connect,
} from "../../atoms/DependencyHelper";
import Image from "../../atoms/image/image";
import ButtonComponent from "../../atoms/button/ButtonComponent";
import { fetchAlternateNumbers, updateSelectedData, displayHideUpgradeModal, fetchCreditFilters, updateData, updatedNextMsisdnSelected } from "../../../Redux/actions/upgradeAction";
import { checkifUpgradableAndC3D, maskMsisdn } from "../../../services/upgradeService";
import labels from "../../../config/labels";
import styles from "./UpgradeInfoBanner.module.scss";
import UpgradeDropdown from "../../atoms/upgradeDropdown/UpgradeDropdown";

const UpgradeInfoBanner = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const windowSize = componentCheckSize();
  const isMobile = windowSize < MOBILE_WIDTH;
  const infoClass = props?.infoBold ? styles["upgrade-banner-info-bold"] : styles["upgrade-banner-info"];

  var defaultData = props?.allUpgradesData?.filter(item => maskMsisdn(item.msisdn) == maskMsisdn(props.selectedNumber));
  const [selectedItem, setSelectedItem] = useState(defaultData[0]);
  const [linkedNum,setLinkedNum]= useState();
  const [showBanner,setShowBanner]= useState(true);
  const [nextSelectedData, setNextSelectedData] = useState(defaultData[0]);

  useEffect(() => {
    if(checkifUpgradableAndC3D(selectedItem?.resultCode?.toLowerCase())){
      props.fetchCreditFilters(selectedItem?.msisdn);
    }
  },[selectedItem]);

  const scrollToTop = () => {
      // scrolling the window up when closing the modal
      if (isMobile && showBanner) window.scrollTo(0, 0);
  }

  const handleBtnClick = (data, showModal = true) => {
    // props.handleBtnClick(data);
    if(data.mah && checkifUpgradableAndC3D(data?.resultCode?.toLowerCase())){
      props.updateData(data);
      props.updateSelectedData(data);
    }else{
      props.updateData(data);
      props.displayHideUpgradeModal(showModal);
    }
    setSelectedItem(data);
    //setNextSelectedData(data);
    props.setSelectedNumber(data?.msisdn)
    // props.setSelectedAlternative(data);
    // if (!data.mah || !checkifUpgradableAndC3D(data?.resultCode?.toLowerCase())) {
    //   props.displayHideUpgradeModal(!props.showUpgradeModal)
    // }
    // props.updateSelectedData(data);
  }

  const handleDropdownSelect = (num, showModal) => {
    const selData=  props?.allUpgradesData?.filter(item => item.msisdn == num);
    handleBtnClick(selData[0], showModal)
  }

  const handleCTABtnClick = (item) => {
    scrollToTop();
    setShowBanner(!showBanner)
    props.updateSelectedData(item);
  }

  const toggleModal = () => {
    scrollToTop();
    setShowBanner(!showBanner);
  };

  const InfoTextBox = ({inModal}) => {
    const upgradeResponse = (inModal) ? props.tempUpgradeResponse : props.upgradeResponse;
    const displayData = (inModal) ? props.tempDisplayData : props.upgradeResponse;
    return (
      <>
        <CustomContainer className={styles["upgrade-banner-main-text"]}>
          {/* {props?.data?.mainText}
    title: "Yes! You can upgrade right now!",
                     */}
          {inModal? displayData?.resultTitle: "Yes! You can upgrade right now!"}
        </CustomContainer>

        {( checkifUpgradableAndC3D(upgradeResponse?.resultCode?.toLowerCase()) ? labels.upgrade.lbl_scroll_desc: <CustomContainer className={styles["upgrade-banner-sub-text"]} dangerouslySetInnerHTML={{__html:displayData?.resultHTML
            ? displayData?.resultHTML
            : displayData?.resultText || ""}}>
        </CustomContainer>)}
        {(!checkifUpgradableAndC3D(upgradeResponse?.resultCode?.toLowerCase()) && upgradeResponse?.upgradeDate) && (
          <CustomContainer className={styles["info-text"]}>
            {upgradeResponse?.upgradeDate}
          </CustomContainer>
        )}
        {props?.allUpgradesData && props?.allUpgradesData?.length == 1 && (
          <>
            <CustomContainer className={infoClass}>
              {"This is the number you can upgrade right now:"}
            </CustomContainer>
            <CustomContainer className={styles["info-label"]}>
              {maskMsisdn(props.allUpgradesData[0].msisdn)}
            </CustomContainer>
          </>
        )}
        {props?.allUpgradesData && props?.allUpgradesData?.length > 1 && upgradeResponse.upgradeEligible && (
          <>
            <CustomContainer className={windowSize > MOBILE_WIDTH ? styles["upgrade-banner-info-bold"]:styles["upgrade-banner-info"]}>
              {`You've got more than one upgradeable number! `}
              <CustomContainer>
                {` Which one would you like to upgrade?`}
              </CustomContainer>
            </CustomContainer>
          </>
        )}
      </>
    )
  }

  const Selections = ({ sizeType, showModal = true }) => {
    let upperLimit = 0;
    if(sizeType == "desktop") {
      upperLimit = 4;
    } else if (sizeType == "tablet" || sizeType == "mobile") {
      upperLimit = 3;
    }
    let msisdnsList = props.allUpgradesData.map((item, index) => {
      return {
        num: item.msisdn,
        id: index + 1,
        label: item.upgradeEligible
            ? `${maskMsisdn(item.msisdn)} (Upgradeable)`
            : `${maskMsisdn(item.msisdn)} (Not upgradeable)`,
      }
    })
    const handleDropdownVal = (val) => {
      msisdnsList.forEach(item => {
        if(item.label === val) {
          handleDropdownSelect(item.num, showModal)
        }
      })
    }
    return (
      <>
        {(props.allUpgradesData && props.allUpgradesData.length >= 2 && props.allUpgradesData.length <= upperLimit) && (
          <CustomContainer className={styles["button-container"]}>
            {props.allUpgradesData.map((item,idx) => {
              return (
                <ButtonComponent
                  className={`${(showModal ? props.upgradeResponse?.msisdn === item?.msisdn : props.tempUpgradeResponse?.msisdn === item?.msisdn) ? styles["button-selected"] : styles["button"]} ${!item.upgradeEligible ? styles["button-disabled"]: ""}`}
                  textClassName={(showModal ? props.upgradeResponse?.msisdn === item?.msisdn : props.tempUpgradeResponse?.msisdn === item?.msisdn) ? styles["button-selected-text"] : styles["button-text"]}
                  text={maskMsisdn(item.msisdn)}
                  key={"btn_" + idx}
                  onBtnClick={() => handleBtnClick(item, showModal)}
                />
              )
            })}
          </CustomContainer>
        )}
        {(props.allUpgradesData && props.allUpgradesData.length > upperLimit && (
          isMobile ? <select
            className={styles["upgrade-select"]}
            onChange={(event) => handleDropdownSelect(event.target.value, showModal)}
          >
            {props.allUpgradesData &&
            props.allUpgradesData.map((item,index) =>
              <option key={index} selected={(showModal ? props.upgradeResponse?.msisdn === item?.msisdn : props.tempUpgradeResponse?.msisdn === item?.msisdn) ? "selected": ""} value={item.msisdn}>
                {maskMsisdn(item.msisdn)}{`(${item?.upgradeEligible ?"Upgradeable":"Not upgradeable"})`}
              </option>)}
          </select>
          : <UpgradeDropdown 
            selectedValue={showModal ? `${maskMsisdn(props.upgradeResponse?.msisdn)} ${props.upgradeResponse?.upgradeEligible ? "(Upgradeable)": "(Not upgradeable)" }` :`${maskMsisdn(props.upgradeResponse?.msisdn)} ${props.upgradeResponse?.upgradeEligible ? "(Upgradeable)": "(Not upgradeable)" }` }
            optionsList={msisdnsList}
            handleSelect={handleDropdownVal}
            showIcon={true}
          />
        ))}
      </>
    )
  }

  return (
    <>
      {showBanner && windowSize >= MOBILE_WIDTH && (
        <CustomContainer>
          <Row>
            <Col md={12}>
              <CustomContainer className={styles["upgrade-banner-wrapper"]}>
                <Image
                  className={styles["upgrade-banner-mark"]}
                  img_path={props?.displayData?.icon}
                  alt="banner-mark"
                />
                <InfoTextBox />
                <CustomContainer className="d-none d-lg-block mt-m">
                  <Selections sizeType="desktop" />
                </CustomContainer>
                <CustomContainer className="d-none d-md-block d-lg-none d-sm-block mt-m">
                  <Selections sizeType="tablet" />
                </CustomContainer>
              </CustomContainer>
            </Col>
          </Row>
        </CustomContainer>
      )}
      {showBanner && isMobile && (
        <Modal
          show={showBanner}
          dialogClassName={` select-modal ${styles["upgrade-banner-wrapper-modal"]}`}
        >
          <Modal.Header className={styles["modal-header"]}>
            <Image
              className={styles["close-button"]}
              img_path={`${imagePrefix}/assets/images/close-black.svg`}
              alt="close"
              onClick={toggleModal}
            />
          </Modal.Header>
          <Modal.Body className={styles["modal-body"]}>
            <CustomContainer style={{textAlign: "center"}}>
              <Image
                className={styles["upgrade-banner-mark-modal"]}
                img_path={props?.tempDisplayData?.icon}
                alt="banner-mark"
              />
            </CustomContainer>
            <InfoTextBox inModal={true}/>
            <Selections sizeType="mobile" showModal={false}/>
            <CustomContainer className={styles["button-container"]}>
              <ButtonComponent
                className={props?.tempUpgradeResponse?.upgradeEligible ? styles["cta-button"] : styles["cta-button-disabled"]}
                textClassName={props?.tempUpgradeResponse?.upgradeEligible ? styles["cta-button-text"] : styles["cta-button-text-disabled"]}
                text={props.allUpgradesData.length > 1 ? labels.upgrade.lbl_upgrade_number : props?.displayData?.primaryCTAText}
                disabledFlag={!props?.tempUpgradeResponse?.upgradeEligible}
                onBtnClick={() => handleCTABtnClick(selectedItem)}
              />
            </CustomContainer>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
};

UpgradeInfoBanner.propTypes = {
  data: PropTypes.any,
  infoBold: PropTypes.bool,
  handleBtnClick: PropTypes.func,
  handleDropdownSelect: PropTypes.func,
  toggleModal: PropTypes.func,
  handleCTAClick: PropTypes.func,
  ctaButtonText: PropTypes.string,
  displayData: PropTypes.any,
  allUpgradesData: PropTypes.any,
  upgradeResponse: PropTypes.any,
  tempDisplayData: PropTypes.any,
  tempUpgradeResponse: PropTypes.any,
};

const mapStateToProps = (state) => ({
  showUpgradeModal: state.upgrade.showModal,
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  upgradeResponse: state.upgrade.selectedUpgradeResponse,
  displayData: state.upgrade.selectedUpgradeDisplayData,
  tempDisplayData: state.upgrade.upgradeDisplayData,
  tempUpgradeResponse: state.upgrade.upgradeResponse,
  linkedNumbers: state.upgrade.linkedNumbers,
  allUpgradesData:state.upgrade.allUpgradesData,
  isNextMsisdnSelected: state.upgrade.isNextMsisdnSelected,
  msisdn:state.upgrade.msisdn,

});

export default connect(mapStateToProps,{
  fetchAlternateNumbers,
  updateSelectedData,
  updateData,
  displayHideUpgradeModal,
  fetchCreditFilters,
  updatedNextMsisdnSelected
}) (UpgradeInfoBanner);
